import React from 'react';
import * as _ from 'lodash';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import Helmet from 'react-helmet';

import {
  EXISTANCE_FLAG,
  HEADER_CONSTANTS, // ヘッダータイトル
  OTHER_SUBSCRIPTION_INSURANCE_STATUSES,
  EXCLUDE_KEY_COMPANY_BRANCH_PERMISSIONS,
  PERMISSION_GROUP_TYPE,
} from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility';
import { isPrimeRoleId } from '../utilities/roleUtility';

import {
  PrimeCompanyForm,
  PrimeCompanySaftyForm,
} from '../components/forms/PrimeCompany'; // フォーム
import Information from '../components/modals/common/Information';
import { CompanyService } from '../services/Companies';
import { AttachDocuments } from '../services/AttachDocuments';
import { UserProfileService } from '../services/UserProfiles'; // ユーザー情報API
import { PrimaryCompanyNaviList } from '../components/list/PrimaryCompanyNaviList';
import { GreenService } from '../services/GreenFile'; // 労安項目情報API
import { RegionalDevelopmentBureauxService } from '../services/RegionalDevelopmentBureaux'; // 振興局情報API
import LocalStorageService from '../services/utilities/LocalStorageService';
import { isLoginUserPartner } from '../utilities/roleUtility';
import SessionStorageService from '../../src/services/utilities/SessionStorageService';
import { attachDocumentCompanyDownload } from '../utilities/attachDocumentUtil';
import { MasterPageHeader } from '../components/PageHeader';

/**
 * 会社情報確認 画面
 *  元請用
 * 画面遷移
 *  - 本社管理者でログイン > 会社情報確認
 */
export class PrimeCompanyPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: LocalStorageService.getUserId(),
      roleId: LocalStorageService.getRoleId(),
      companyId: SessionStorageService.getCompanyId(),
      visibleDialogFlag: false,
      use_greenfile_flg: '', // 労務安全使用フラグ
      checkboxList: {
        construct_permit_source_types: {}, // 許可元区分名
        construct_permit_types: {}, // 建設許可区分名
        insurance_statuses: {}, // 健康保険、年金保険、雇用保険の加入状態
        workmans_compensation_insurance_statuses: {}, // 労災保険特別加入状況
        kentaikyo_insurance_statuses: {}, // 建退共制度加入状況
        chutaikyo_insurance_statuses: {}, // 中退共制度加入状況
        other_subscription_insurance_statuses: OTHER_SUBSCRIPTION_INSURANCE_STATUSES, //その他退職金共済制度加入状況
      },
      documentCodes: [],
      RegionalDebureaux: [], // 振興局（APIから取得）

      formValues: {
        name: '', // 会社名
        kana: '', // 会社名かな
        postal_code: '', // 郵便番号
        prefectures_code_id: '', // 都道府県
        city_name: '', // 市区町村
        street_number: '', // 丁目・番地
        building_name: '', // 建物名・部屋番号
        tel: '', // 電話番号
        fax: '', // FAX
        company_icon_image_url: '', // 会社ロゴ
        joining_flag: '', // 共通化状態
        common_partner_company_code: '', // 協力会社コード
      },

      safetyValues: {
        // 代表者情報
        company_detail: {
          delegate_name: '', // 代表者名
          delegate_name_kana: '', // 代表者名フリガナ
          delegate_post: '', // 代表者名役職
          construction_industry_permission_flag: EXISTANCE_FLAG.NOEXIST.VALUE,
          acceptance_foreign_workers_flag: 0, // 外国人就労者受入有無
        },
        old_company_permission_documents: [],

        // 許可情報
        company_branch_permissions: [],
        // 保険情報
        company_branch_insurance: {
          health_insurance_flag: '', // 健康保険_加入状況
          ccus_health_insurance_reason_exclusion_code: '', // 社会保険適用外理由コード_健保
          health_insurance_reason_exclusion: '', // 健康保険_適用除外理由
          health_insurance_type_code: '', // 健康保険_健康保険種類コード
          health_insurance_type: '', // 健康保険_健康保険種類
          health_insurance_name_insurer: '', // 健康保険_健康保険者名称
          health_insurance_office_symbol: '', // 健康保険_事業所整理記号
          health_insurance_office_number: '', // 健康保険_事業所整理番号
          pension_flag: '', // 年金保険_加入状況
          ccus_pension_reason_exclusion_code: '', // 社会保険適用外理由コード_年金
          pension_reason_exclusion: '', // 年金保険_適用除外理由
          pension_type_code: '', // 年金保険_年金種類コード
          pension_type: '', // 年金保険_年金保険種類名称
          pension_office_symbol: '', // 年金保険_事業所整理記号
          pension_office_number: '', // 年金保険_事業所番号
          employment_insurance_flag: '', // 雇用保険_加入状況
          ccus_employment_insurance_reason_exclusion_code: '', // 社会保険適用外理由コード_雇用
          employment_insurance_reason_exclusion: '', // 雇用保険_適用除外理由
          employment_insurance_insurance_number: '', // 雇用保険_労働保険番号
          worker_compensation_flag: '', // 労災保険特別加入_加入状況
          worker_compensation_number: '', // 労災保険特別加入_労働保険番号
          worker_compensation_organize_number: '', // 労災保険特別加入_整理番号
          worker_add_on_compensation_flag: '', // 労災保険_労災上乗保険_加入状況
          const_subscription_flag: '', // 建設業退職金共済制度加入状況
          const_subscription_number: '', // 建設業退職金共済契約者番号
          enterprise_subscription_flag: '', // 中小企業退職金共済制度_加入状況
          enterprise_subscription_number: '', // 中小企業退職金共済契約者番号
          other_subscription_flag: '', // その他退職金共済制度加入状況
          other_subscription_name: '', // その他退職金共済制度名称
        },

        // 外国人就労者情報
        company_branch_foreigner: {
          certification_number: '', // 適正監理計画認定番号
          supervisor_worker_id: '', // ワーカーID_受入監理責任者
          supervisor_name: '', // ワーカー名_受入監理責任者
          supervisor_position_name: '', // 役職名_受入監理責任者
          leader_worker_id: '', // ワーカーID_受入監理指導員
          work_place: '', // 外国人就労者_就労場所
          engagement_content: '', // 外国人就労者_従事業務内容
          engagement_start_date: '', // 外国人就労者_従事開始年月日
          engagement_end_date: '', // 外国人就労者_従事終了年月日
        },
      },
      expirationCompany: {},
    };

    this.events = {
      form: {
        download: this.download.bind(this),
      },
    };

    this.initForm = this.initForm.bind(this); // フォーム生成
    this.getCompany = this.getCompany.bind(this); // 自社情報取得
    this.setPrimeCompanyEdit = this.setPrimeCompanyEdit.bind(this); // 編集画面へと遷移
  }

  getExpiration = async () => {
    await CompanyService.expirations(this.state.companyId).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        expirationCompany: {
          ...this.state.expirationCompany,
          ...response.data.entities.company.expiration,
        },
      });
    });
  };

  componentDidMount() {
    this.getCompany();
    const params = {
      offset: 0,
      is_limit: 0,
    };
    AttachDocuments.documentCodes(params).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        documentCodes: response.data.entities.document_codes,
      });
    });
    CompanyService.companyDocuments(this.state.companyId, params).then(
      response => {
        if (!response.result) {
          return;
        }
        this.setState({
          companyDocuments: response.data.entities.company_documents,
        });
      }
    );
    this.getExpiration();
  }

  getCompany() {
    UserProfileService.show(this.state.userId, {}).then(response => {
      // console.log('PrimeCompanyPreview.jsx getCompany', response);
      if (response.result) {
        const entity = response.data.entities;
        const formValue = _.cloneDeep(this.state.formValues);

        let company, company_icon_image_url;
        if (isLoginUserPartner()) {
          const sessionPrimeCompanyId = SessionStorageService.getItem(
            'sessionPartnerCompanyIdOfPrimeCompany'
          );
          if (sessionPrimeCompanyId) {
            company = _.find(response.data.entities.company, company => {
              return String(company.id) === sessionPrimeCompanyId;
            });
            if (company.icon_image) {
              company_icon_image_url = `${
                window.location.origin
              }/applications/images/company/${company.icon_image}`;
            } else if (entity.image) {
              company_icon_image_url = `${
                window.location.origin
              }/applications/images/company/${entity.image.name}`;
            }
          }
        } else {
          company = entity.company[0];
          company_icon_image_url = entity.company_icon_image_url;
        }
        formValue.company_icon_image_url = company_icon_image_url;

        this.setState({
          formValues: formValue,
          use_greenfile_flg: entity.use_greenfile_flg,
        });
        this.initForm(company);
        if (entity.use_greenfile_flg === 1) {
          this.getSafety(company.id);
        }

        const { joining_flag, one_master_flag } = company;
        if (
          joining_flag === 1 &&
          (one_master_flag === null || one_master_flag === 0)
        ) {
          throw new Error(
            'PrimeCompanyPreview.jsx getCompany joining_flag one_master_flag'
          );
          // 元請の処理なので、常に法人のため法人判定が必要ない
          // ということをリファクタリングのために確定するための判定処理
        }
      }
    });
  }

  async download(fileId) {
    attachDocumentCompanyDownload(
      () => {
        this.setState({
          visibleDialogFlag: true,
        });
      },
      this.state.companyId,
      fileId
    );
  }

  /**
   * フォーム生成
   * @param company {object} 会社情報
   */
  initForm(company) {
    const formValues = _.cloneDeep(this.state.formValues);

    // 会社情報
    _.each(company, (company_data, index) => {
      if (_.has(formValues, index)) {
        formValues[index] = company_data ? company_data : '';
      }
    });

    this.setState({
      formValues,
    });
  }

  getSafety(company_id) {
    GreenService.list(company_id).then(response => {
      if (!response.result) {
        return;
      }
      const safetyValues = _.cloneDeep(this.state.safetyValues);
      const data = response.data.entities;
      _.map(data, (company_data, company_key) => {
        if (!_.includes(EXCLUDE_KEY_COMPANY_BRANCH_PERMISSIONS, company_key)) {
          _.map(company_data, (data, key) => {
            safetyValues[company_key][key] = data;
          });
        }
      });
      safetyValues.old_company_permission_documents = _.get(
        data,
        'old_company_permission_documents'
      );
      safetyValues.company_branch_permissions = _.get(
        data,
        'common_company_branch_permission_groups'
      );
      this.setState({ safetyValues });
    });
    GreenService.ccus_list().then(response => {
      if (!response.result) {
        return;
      }
      const checkboxList = { ...this.state.checkboxList };
      const data = response.data.entities;
      _.map(data, (ccus_list_data, ccus_list_key) => {
        if (_.has(checkboxList, ccus_list_key)) {
          checkboxList[ccus_list_key] = ccus_list_data;
        }
      });
      this.setState({ checkboxList });
    });
    // 振興局情報APIから取得
    RegionalDevelopmentBureauxService.list().then(response => {
      if (!response.result) {
        return;
      }
      const bureaux = response.data.entities.regional_development_bureaux;
      this.setState({ bureaux });
    });
  }

  setPrimeCompanyEdit() {
    _masterSlideLoader.show('PrimeCompanyEdit', {
      state: {
        id: this.state.companyId,
      },
    });
  }

  closeError = () => {
    this.setState({
      visibleDialogFlag: false,
    });
  };

  render() {
    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - 会社情報</title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title={'会社情報'}
            onClose={() => _masterSlideLoader.close()}
          />
          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                <PrimaryCompanyNaviList
                  isSelectedHeadOfficeInformation={true}
                  expirationCompany={this.state.expirationCompany}
                />
              </div>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                {isPrimeRoleId(this.state.roleId) && (
                  <React.Fragment>
                    <div className='contruction-detail-view__menu'>
                      <span className='construction-detail-view__button'>
                        <button
                          className='btn'
                          onClick={this.setPrimeCompanyEdit}
                        >
                          編集
                        </button>
                      </span>
                    </div>
                    <div className='contruction-detail-view__bar' />
                  </React.Fragment>
                )}
                <PrimeCompanyForm
                  values={this.state.formValues}
                  use_greenfile_flg={this.state.use_greenfile_flg}
                  events={{}}
                  messages={{}}
                  readOnly={true}
                  image={this.state.formValues.company_icon_image_url}
                  PrimeCompanySaftyForm={
                    <PrimeCompanySaftyForm
                      values={this.state.safetyValues}
                      messages={{}}
                      checkboxList={this.state.checkboxList}
                      comboboxList={{}}
                      events={this.events.form}
                      readOnly={true}
                      companyDocuments={this.state.companyDocuments}
                      documentCodes={this.state.documentCodes}
                      bureaux={this.state.bureaux}
                      selectedCompanyId={this.state.companyId}
                      eventCompanyBranchPermissionCommon={this.events.form}
                    />
                  }
                />
                <Information
                  title={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <i
                        className='icon-error'
                        style={{
                          fontSize: 24,
                          color: 'red',
                        }}
                      />
                      <p>エラーが発生しました。</p>
                    </div>
                  }
                  message={'指定されたファイルが存在しません。'}
                  buttonText={messageUtility.getMessage('I-000-017')}
                  visible={this.state.visibleDialogFlag}
                  onClose={() => {
                    this.closeError();
                  }}
                  multilineText={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PrimeCompanyPreview.jsx